<template>
  <MasterLayout :loading="loading" page_title="ویرایش اطلاعات فایل مشتریان">
    <Card>
      <AjaxForm v-if="userFile" :route="'UserFile/Edit/'+userFile._id">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6">
            <CustomInput v-model="userFile.title" name="title" label="عنوان" type="text" placeholder="عنوان را وارد کنید"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-6">
            <CustomInput v-model="userFile.user_type" label="استفاده برای" type="select" name="user_type" :select-options="userTypeOptions" placeholder="انتخاب کنید"
                         :reduce_select="(option)=>option.name" select-label="title"></CustomInput>
          </div>

          <div class="col-12 col-sm-12 col-md-6 mb-2">
            <div class="custom-control custom-switch">
              <input :checked="userFile.use_in_register" type="checkbox" class="custom-control-input" id="user_in_register" value="1"  name="use_in_register">
              <label class="custom-control-label" for="user_in_register">استفاده در ثبت نام</label>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-6 mb-2">
            <div class="custom-control custom-switch">
              <input :checked="userFile.required" type="checkbox" class="custom-control-input"  value="1" id="required" name="required">
              <label class="custom-control-label" for="required">اجباری</label>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-12">
            <CustomInput v-model="userFile.description" type="textarea" name="description" placeholder="توضیحات" label="توضیحات"></CustomInput>
          </div>
        </div>
        <div class="row">
          <div class="col-10 col-md-5 mx-auto">
            <button class="btn btn-primary btn-block" type="submit">ویرایش اطلاعات</button>
          </div>
        </div>
      </AjaxForm>
      <div v-if="error" class="alert alert-danger">{{error}}</div>
    </Card>
  </MasterLayout>
</template>

<script>
import MasterLayout from "@/components/MasterLayout";
import Card from "@/components/forms/Card";
import AjaxForm from "@/components/forms/AjaxForm";
import CustomInput from "@/components/CustomInput";
import {AppApi} from "@/api/AppApi";

export default {
  name: "UserFileAdd",
  components: {CustomInput, AjaxForm, Card, MasterLayout},
  data(){
    return{
      userTypeOptions:[
          {name : 'person',title : 'شخص حقیقی'},
          {name : 'company',title : 'شخص حقوقی'},
          {name : 'both',title : 'هردو'},
          ],
      loading : false,
      id : this.$route.params.id,
      userFile : null,
      error:null
    }
  },
  mounted()
  {
    this.initPage();
  },
  methods : {
    async initPage()
    {
      this.error = null;
      this.userFile = null;
      this.id = this.$route.params.id;
      this.loading = true;
      const check = await AppApi.getUserFileForEdit(this.id);
      if (check.ok)
      {
        this.userFile = check.userFile;
      }
      else
      {
        this.error = check.error;
      }
      this.loading = false;
    }
  }
}
</script>

<style scoped>

</style>